export default __webpack_public_path__ + "static/media/1 - Организация велопарковок.19ae7be2.jpg";